module.exports = __webpack_public_path__ + "static/img/role.865d955.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/role3/jw/role.png
// module id = G39J
// module chunks = 7